import { Paper } from '@mui/material';
import { BodyPix } from '@tensorflow-models/body-pix';
import { useEffect, useState } from 'react';
import { BackgroundConfig } from '../helpers/backgroundHelper';
import { PostProcessingConfig } from '../helpers/postProcessingHelper';
import { SegmentationConfig } from '../helpers/segmentationHelper';
import { SourceConfig, SourcePlayback } from '../helpers/sourceHelper';
import { TFLite } from '../hooks/useTFLite';
import OutputViewer from './OutputViewer';
import OutputViewerWithoutSource from './OutputViewerWithoutSource';
import SourceViewer from './SourceViewer';

type ViewerCardProps = {
  sourceConfig: SourceConfig;
  backgroundConfig: BackgroundConfig;
  segmentationConfig: SegmentationConfig;
  postProcessingConfig: PostProcessingConfig;
  bodyPix?: BodyPix;
  tflite?: TFLite;
};

function ViewerCard(props: ViewerCardProps) {
  const [sourcePlayback, setSourcePlayback] = useState<SourcePlayback>();

  useEffect(() => {
    setSourcePlayback(undefined);
  }, [props.sourceConfig]);

  return (
    <Paper
      sx={theme => ({
        minHeight: `calc(min(${[`${theme.spacing(60)}`, `100vh - ${theme.spacing(0)}`].join(
          ', ',
        )}))`,
        borderRadius: 0,
        // minHeight: `60vh`,
        display: 'flex',
        overflow: 'hidden',

        [theme.breakpoints.up('md')]: {
          gridColumnStart: 1,
          gridColumnEnd: 2,
        },

        // [theme.breakpoints.up('lg')]: {
        //   gridRowStart: 1,
        //   gridRowEnd: 3,
        // },
      })}
    >
      <SourceViewer sourceConfig={props.sourceConfig} onLoad={setSourcePlayback} />
      {sourcePlayback && props.bodyPix && props.tflite ? (
        <OutputViewer
          sourcePlayback={sourcePlayback}
          backgroundConfig={props.backgroundConfig}
          segmentationConfig={props.segmentationConfig}
          postProcessingConfig={props.postProcessingConfig}
          bodyPix={props.bodyPix}
          tflite={props.tflite}
        />
      ) : (
        <OutputViewerWithoutSource backgroundConfig={props.backgroundConfig} />
        // <Box
        //   sx={{
        //     flex: 1,
        //     display: 'flex',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //   }}
        // >
        //   {/* <Avatar
        //     sx={theme => ({
        //       width: theme.spacing(20),
        //       height: theme.spacing(20),
        //     })}
        //   /> */}
        // </Box>
      )}
    </Paper>
  );
}

export default ViewerCard;
